import { CrossIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { AreaFieldFailureReportSubmitAPI } from "../../areaFieldReports/services/apiCalls";
import { AreaFieldReportsKeys } from "../../areaFieldReports/services/entity";
import { FeatureIcon } from "../assets/svg";
import { FieldFailureReportSubmitAPI } from "../services/apiCalls";
import { FieldFailureReportsKeys } from "../services/entity";
export var SubmitionPopUp = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    var row = data.row, isASMAFR = data.isASMAFR;
    var formData = [{
            type: FormItemTypes.IconButton,
            name: 'icon',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(FeatureIcon, {
                sx: {
                    fontSize: 48
                }
            }),
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: 'close',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CrossIcon, {
                sx: {
                    fontSize: 12
                }
            }),
            onClick: onClose,
            columnSize: 0
        }, {
            type: FormItemTypes.Typography,
            name: 'Msg',
            label: "Are you sure you want to submit?",
            value: null,
            columnSize: 12,
            children: "Document cannot be edited after submission.",
            labelTypographyProps: {
                fontSize: "xl",
                fontWeight: "strong",
                color: "text.primary"
            }
        }, {
            type: FormItemTypes.Button,
            name: 'cancel',
            children: 'Cancel',
            columnSize: 6,
            fullWidth: true,
            variant: 'outlined',
            size: 'small',
            sx: {
                py: 1,
                color: "secondary.500",
                border: '1px solid',
                fontWeight: "medium",
                borderColor: 'secondary.200',
                fontSize: "base"
            },
            onClick: function () {
                onClose();
            }
        }, {
            type: FormItemTypes.Button,
            name: 'Confirm',
            children: 'Confirm',
            columnSize: 6,
            fullWidth: true,
            variant: 'contained',
            size: 'small',
            sx: {
                py: 1,
                color: "primary",
                backgroundColor: "primary",
                fontWeight: "medium",
                fontSize: "base"
            },
            onClick: function () { return 'submit'; }
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            sx: {
                m: 2
            }
        },
        createFormAPI: isASMAFR ? AreaFieldFailureReportSubmitAPI : FieldFailureReportSubmitAPI,
        createKey: isASMAFR ? AreaFieldReportsKeys.update : FieldFailureReportsKeys.update,
        createRequest: isASMAFR ? {
            data: row
        } : {
            id: row === null || row === void 0 ? void 0 : row.id,
            StatusId: row === null || row === void 0 ? void 0 : row.StatusId,
            IsSubmit: 1,
            onClose: onClose
        }
    });
};
